module.exports = __webpack_public_path__ + "static/media/vu.9b6cbbe9.svg";